import { BrowserRouter, Routes, Route } from "react-router-dom";
import * as React from "react";
import { useContext } from "react";
// import { Login } from "@mui/icons-material";

// Importing Pages
import LoginPage from "./pages/LoginPage";
import SectionDisplayPage from "./pages/SectionDisplayPage";
import RepEditPage from "./pages/Representative/RepEditPage";
import HodEditPage from "./pages/HOD/HodEditPage";
import AdminEditPage from "./pages/Admin/AdminEditPage";
import AutoEditPage from "./pages/Autonomous/AutoEditPage";
import PlacementEditPage from "./pages/Placement/PlacementEditPage";
import PAEditPage from "./pages/PA/PAEditPage";
import AcademicEditPage from "./pages/Academic/AcademicEditPage";
import CoeEditPage from "./pages/COE/CoeEditPage";
import DeanEditPage from "./pages/Dean/DeanEditPage";
import NSSEditPage from "./pages/NSS/NSSEditPage";
import NCCEditPage from "./pages/NCC/NCCEditPage";
import PEDEditPage from "./pages/PED/PEDEditPage";
import AdministratorEditPage from "./pages/Administrator/AdministratorEditPage";
import RepPageReport from "./pages/Representative/RepPageReport";
import HodPageReport from "./pages/HOD/HodPageReport";
import AdminPageReport from "./pages/Admin/AdminPageReport";
import AutoPageReport from "./pages/Autonomous/AutoPageReport";
import PlacementPageReport from "./pages/Placement/PlacementPageReport";
import PAPageReport from "./pages/PA/PAPageReport";
import AcademicPageReport from "./pages/Academic/AcademicPageReport";
import CoePageReport from "./pages/COE/CoePageReport";
import DeanPageReport from "./pages/Dean/DeanPageReport";
import NSSPageReport from "./pages/NSS/NSSPageReport";
import NCCPageReport from "./pages/NCC/NCCPageReport";
import PEDPageReport from "./pages/PED/PEDPageReport";
import AdministratorPageReport from "./pages/Administrator/AdministratorPageReport";
import HodEdit from "./pages/HOD/HodEdit";
import AutoEdit from "./pages/Autonomous/AutoEdit";
import PlacementEdit from "./pages/Placement/PlacementEdit";
import PAEdit from "./pages/PA/PAEdit";
import AcademicEdit from "./pages/Academic/AcademicEdit";
import CoeEdit from "./pages/COE/CoeEdit";
import DeanEdit from "./pages/Dean/DeanEdit";
import NCCEdit from "./pages/NCC/NCCEdit";
import NSSEdit from "./pages/NSS/NSSEdit";
import PEDEdit from "./pages/PED/PEDEdit";
import AdministratorEdit from "./pages/Administrator/AdministratorEdit";
import ResetPasswordPage from "./pages/resetPassword";
// Importing context providers
import { AuthContext } from "./context/AuthContext";
import { ReportContentContextProvider } from "./providers/reportContentProvider";
import { CoeReportContentContextProvider } from "./providers/coeReportContentProvider";
import { DeanReportContentContextProvider } from "./providers/deanReportContentProvider";
import { NssReportContentContextProvider } from "./providers/nssReportContentProvider";
import { NccReportContentContextProvider } from "./providers/nccReportContentProvider";
import { AutoReportContentContextProvider } from "./providers/autoReportContentProvider";
import { PlacementReportContentContextProvider } from "./providers/placementReportContentProvider";
import { PAReportContentContextProvider } from "./providers/PAReportContentProvider";
import { AcademicReportContentContextProvider } from "./providers/academicReportContentProvider";
import { PEDReportContentContextProvider } from "./providers/PEDReportContentProvider";
import { AdministratorReportContentContextProvider } from "./providers/administratorReportContentProvider";
import IICPageReport from "./pages/IIC/IICPageReport";
import IICEditPage from "./pages/IIC/IICEditPage";
import { IICReportContentContextProvider } from "./providers/iicReportContentProvider";
import IICEdit from "./pages/IIC/IICEdit";
import AccountPageReport from "./pages/Account/AccountPageReport";
import AccountEditPage from "./pages/Account/AccountEditPage";
import AccountEdit from "./pages/Account/AccountEdit";
import { AccountReportContentContextProvider } from "./providers/accountReportContentProvider";
import PsgTrainingPageReport from "./pages/PsgTraining/PsgTrainingPageReport";
import PsgTrainingEditPage from "./pages/PsgTraining/PsgTrainingEditPage";
import PsgTrainingEdit from "./pages/PsgTraining/PsgTrainingEdit";
import { PsgTrainingReportContentContextProvider } from "./providers/psgtrainingReportContentProvider";
import AluminiPageReport from "./pages/Alumini/AluminiPageReport";
import AluminiEditPage from "./pages/Alumini/AluminiEditPage";
import { AluminiAssociationReportContentContextProvider } from "./providers/aluminiReportContentProvider";
import AluminiEdit from "./pages/Alumini/AluminiEdit";

function App() {
  const { user } = useContext(AuthContext);
  return (
    <BrowserRouter>
      <Routes>
        {/* 
          Conditional Routing Based on User Roles 
          Uncomment the appropriate routes based on your authentication logic.
        */}
        {/*<Route exact path="/" element={user?<RepPageReport/>:<LoginPage />} />
          <Route exact path={user ? "/Rep":"/"} element={user ? <RepPage /> : <LoginPage />} />
          <Route path="/RepEdit/:id" element={ //localStorage.getItem("jwt") !== null && localStorage.getItem("role")==="REPRESENTATIVE"? (user ? (<ReportContentContextProvider> <RepEditPage /></ReportContentContextProvider>) : (<LoginPage />)//) : (// <LoginPage />//)}/>
          <Route path="/Hod" element={//localStorage.getItem("jwt") !== null && localStorage.getItem("role")==="HOD"? user ? <HodPage /> : <LoginPage />//: <LoginPage />}/>
          <Route path="/HodEdit/:id" element={//localStorage.getItem("jwt") !== null && localStorage.getItem("role")==="HOD"? (user ? <HodEditPage /> : <LoginPage />//) : (//<LoginPage />//)}/>
          <Route path="/Admin" element={//localStorage.getItem("jwt") !== null && localStorage.getItem("role")==="ADMIN" ? user ? <AdminPage /> : <LoginPage />//: <LoginPage />}/>
          <Route path="/AdminEdit/:id" element={// localStorage.getItem("jwt") !== null &&// localStorage.getItem("role") === "ADMIN" user ? <AdminEditPage /> : <LoginPage />}/>
          <Route path={user?"/representative":"/"} element={user ? <RepPageReport /> : <LoginPage />}/>
          <Route path={user?"/hod":"/"} element={user ? <HodPageReport /> : <LoginPage />} />
          <Route path={user?"/admin":"/"} element={user ? <AdminPageReport /> : <LoginPage />}/> 
        */}

        {/* Main Route */}
        <Route
          exact
          path="/"
          element={
            // localStorage.getItem("jwt") !== null &&
            // localStorage.getItem("role") === "REPRESENTATIVE"
            user === "REPRESENTATIVE" ? (
              <RepPageReport />
            ) : // localStorage.getItem("jwt") !== null &&
            // localStorage.getItem("role") === "HOD"
            user === "HOD" ? (
              <HodPageReport />
            ) : // localStorage.getItem("jwt") !== null &&
            // localStorage.getItem("role") === "ADMIN"
            user === "ADMIN" ? (
              <AdminPageReport />
            ) :
            (user === "REPRESENTATIVE" && localStorage.getItem('departmentId') === "AUTONOMOUS" ) ? (
              <AutoPageReport/>
            ) :
            (user === "REPRESENTATIVE" && localStorage.getItem('departmentId') === "PLACEMENT" ) ? (
              <PlacementPageReport/>
            ) :
            (user === "REPRESENTATIVE" && localStorage.getItem('departmentId') === "PA" ) ? (
              <PAPageReport/>
            ) :
            (user === "REPRESENTATIVE" && localStorage.getItem('departmentId') === "ACADEMIC" ) ? (
              <AcademicPageReport/>
            ) :
            (user === "REPRESENTATIVE" && localStorage.getItem('departmentId') === "COE" ) ? (
              <CoePageReport/>
            ) :
            (user === "REPRESENTATIVE" && localStorage.getItem('departmentId') === "IQAC" ) ? (
              <DeanPageReport/>
            ) :
            (user === "REPRESENTATIVE" && localStorage.getItem('departmentId') === "NSS" ) ? (
              <NSSPageReport />
            ) : user === "REPRESENTATIVE" &&
              localStorage.getItem("departmentId") === "NCC" ? (
              <NCCPageReport />
            ) :user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ACCOUNT" ? (
            <AccountPageReport />
          ) : (
              <LoginPage />
            )
          }
        />

        {/* <Route
          path="/HodPage"
          element={
            // localStorage.getItem("jwt") !== null &&
            // localStorage.getItem("role") === "HOD"
            user === "HOD" ? <HodPage /> : <LoginPage />
          }
        /> */}
        {/* <Route
          path="/Rep"
          element={
            // localStorage.getItem("jwt") !== null &&
            // localStorage.getItem("role") === "REPRESENTATIVE"
            user === "REPRESENTATIVE" ? <RepPage /> : <LoginPage />
          }
        /> */}

        {/* Routes for each role's edit page */}
        <Route
          path="/hodEdit/:id/:currentYear/:currentQuarter"
          element={
            // localStorage.getItem("jwt") !== null &&
            // localStorage.getItem("role") === "HOD"
            user === "HOD" ? <HodEditPage /> : <LoginPage />
          }
        />
        <Route
          path="/sec/:id/:currentYear/:currentQuarter"
          element={
            // localStorage.getItem("jwt") !== null &&
            // localStorage.getItem("role") === "REPRESENTATIVE"
            user === "REPRESENTATIVE" ? <SectionDisplayPage /> : <LoginPage />
          }
        />
        <Route
          path="/representative"
          element={
            user === "REPRESENTATIVE" ? <RepPageReport /> : <LoginPage />
          }
        />
        <Route
          path="/hod"
          element={user === "HOD" ? <HodPageReport /> : <LoginPage />}
        />
        <Route
          path="/admin"
          element={user === "ADMIN" ? <AdminPageReport /> : <LoginPage />}
        />
        <Route
          path="/representativeEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            // localStorage.getItem("jwt") !== null &&
            // localStorage.getItem("role") === "REPRESENTATIVE"
            user === "REPRESENTATIVE" ? (
              <ReportContentContextProvider>
                <RepEditPage />
              </ReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/hodQuillEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            // localStorage.getItem("jwt") !== null &&
            // localStorage.getItem("role") === "REPRESENTATIVE"
            user === "HOD" ? (
              <ReportContentContextProvider>
                <HodEdit />
              </ReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/adminEdit/:currentYear/:currentQuarter"
          element={
            // localStorage.getItem("jwt") !== null &&
            // localStorage.getItem("role") === "ADMIN"
            user === "ADMIN" ? <AdminEditPage /> : <LoginPage />
          }
        />
        <Route
          path="/autonomous"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "AUTONOMOUS" ? (
              <AutoPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/autoEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "AUTONOMOUS" ? (
              <AutoEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/autoJoditEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "AUTONOMOUS" ? (
              <AutoReportContentContextProvider>
                <AutoEdit />
              </AutoReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/placement"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PLACEMENT" ? (
              <PlacementPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/placementEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PLACEMENT" ? (
              <PlacementEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/placementJoditEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PLACEMENT" ? (
              <PlacementReportContentContextProvider>
                <PlacementEdit />
              </PlacementReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/pa"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PA" ? (
              <PAPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/paEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PA" ? (
              <PAEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/paQuillEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PA" ? (
              <PAReportContentContextProvider>
                <PAEdit />
              </PAReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/academic"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ACADEMIC" ? (
              <AcademicPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/academicEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ACADEMIC" ? (
              <AcademicEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/academicQuillEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ACADEMIC" ? (
              <AcademicReportContentContextProvider>
                <AcademicEdit />
              </AcademicReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/coe"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "COE" ? (
              <CoePageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/coeEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "COE" ? (
              <CoeEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/coeQuillEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "COE" ? (
              <CoeReportContentContextProvider>
                <CoeEdit />
              </CoeReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/dean"
          element={(user === "REPRESENTATIVE" && localStorage.getItem('departmentId') === "IQAC" ) ? <DeanPageReport /> : <LoginPage />}
        />  
        <Route
          path="/deanEdit/:id/:currentYear/:currentQuarter"
          element={
            (user === "REPRESENTATIVE" && localStorage.getItem('departmentId') === "IQAC" ) ? <DeanEditPage/> : <LoginPage/>
          }
        />
        <Route
          path="/deanQuillEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            (user === "REPRESENTATIVE" && localStorage.getItem('departmentId') === "IQAC" ) ? (
              <DeanReportContentContextProvider>
                <DeanEdit />
              </DeanReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/nss"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "NSS" ? (
              <NSSPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/nssEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "NSS" ? (
              <NSSEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/NSSQuillEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "NSS" ? (
              <NssReportContentContextProvider>
                <NSSEdit />
              </NssReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/ncc"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "NCC" ? (
              <NCCPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/nccEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "NCC" ? (
              <NCCEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/nccQuillEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "NCC" ? (
              <NccReportContentContextProvider>
                <NCCEdit />
              </NccReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />

        <Route
          path="/ped"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PED" ? (
              <PEDPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/pedEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PED" ? (
              <PEDEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/pedQuillEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PED" ? (
              <PEDReportContentContextProvider>
                <PEDEdit />
              </PEDReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />

        <Route
          path="/administrator"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ADMINISTRATOR" ? (
              <AdministratorPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/administratorEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ADMINISTRATOR" ? (
              <AdministratorEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/administratorQuillEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ADMINISTRATOR" ? (
              <AdministratorReportContentContextProvider>
                <AdministratorEdit />
              </AdministratorReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />


        <Route
          path="/iic"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "IIC" ? (
              <IICPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/iicEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "IIC" ? (
              <IICEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/iicQuillEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "IIC" ? (
              <IICReportContentContextProvider>
                <IICEdit />
              </IICReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />

        <Route
          path="/account"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ACCOUNT" ? (
              <AccountPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/accountEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ACCOUNT" ? (
              <AccountEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/accountQuillEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ACCOUNT" ? (
              <AccountReportContentContextProvider>
                <AccountEdit />
              </AccountReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />
        {/* psgtrainging */}
        <Route
          path="/psgtraining"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PSGII - TRAINING DEPT" ? (
              <PsgTrainingPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/psgTrainingEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PSGII - TRAINING DEPT" ? (
              <PsgTrainingEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/psgTrainingJoditEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "PSGII - TRAINING DEPT" ? (
              <PsgTrainingReportContentContextProvider>
                <PsgTrainingEdit />
              </PsgTrainingReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />

        {/* alumini association */}
        <Route
          path="/alumini"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ALUMNI ASSN" ? (
              <AluminiPageReport />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/aluminiEdit/:id/:currentYear/:currentQuarter"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ALUMNI ASSN" ? (
              <AluminiEditPage />
            ) : (
              <LoginPage />
            )
          }
        />
        <Route
          path="/AluminiJoditEdit/:id/:currentYear/:currentQuarter/:title"
          element={
            user === "REPRESENTATIVE" &&
            localStorage.getItem("departmentId") === "ALUMNI ASSN" ? (
              <AluminiAssociationReportContentContextProvider>
                <AluminiEdit />
              </AluminiAssociationReportContentContextProvider>
            ) : (
              <LoginPage />
            )
          }
        />

        <Route 
          path='/reset-password'
          element={<ResetPasswordPage/>}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
